/* REGION : VN & MY */
//import all svg files for ShopeeLogo
// import QR from "../../../Assets/Icons/ShopeeLogo/QR.png";
import QR from 'src/Components/MerchantPage/Assets/Imgs/shopeePayQr.png'
import QRVN from '../../../Assets/Icons/ShopeeLogo/QR_VN.png'
import shopeeLogo from '../../../Assets/Icons/ShopeeLogo/shopeeLogo.svg'

const reqSvgLogo = require.context(
  'src/Common/Assets/Icons/ShopeeLogo/',
  true,
  /\.svg$/
)
const svgFileLogoPaths = reqSvgLogo.keys()
//import all svg files for Socials
const reqSvgSocial = require.context(
  'src/Common/Assets/Icons/Socials/',
  true,
  /\.svg$/
)
const svgFileSocialPaths = reqSvgSocial.keys()
//import all svg files for App Stores
const reqSvgApp = require.context(
  'src/Common/Assets/Icons/AppStore/',
  true,
  /\.svg$/
)
const svgFileAppPaths = reqSvgApp.keys()

const reqPngIcons = require.context(
  'src/Common/Components/AppFooter/Assets/Icons/Png',
  true,
  /\.png$/
)
const pngFileIconsPaths = reqPngIcons.keys()

//images
//shopee logo
export const shopeeLogoEng = shopeeLogo
export const shopeeLogoMy = shopeeLogo
export const shopeeLogoVn = shopeeLogo

//Qr code
export const QREng = [
  {
    img: QR,
    link: ' https://shopee.com.my/web',
    description: 'ENG QR code',
    width: '110px'
  }
]

export const QRMy = [
  {
    img: QR,
    link: 'https://shopee.com.my/web',
    description: 'MY QR code',
    width: '110px'
  }
]

export const QRVn = [
  {
    img: QRVN,
    link: 'https://shopee.vn/download?pid=Organic&c=lp_home_qr',
    description: 'VN QR code',
    width: '110px'
  }
]

//social media icons
export const socialsEng = [
  {
    img: reqSvgSocial(svgFileSocialPaths[0]),
    link: ' https://www.facebook.com/ShopeePayMY ',
    description: 'facebook icon'
  },
  {
    img: reqSvgSocial(svgFileSocialPaths[1]),
    link: 'https://www.instagram.com/shopeepay_my/ ',
    description: 'instagram icon'
  }
]

export const socialsMy = [
  {
    img: reqSvgSocial(svgFileSocialPaths[0]),
    link: ' https://www.facebook.com/ShopeePayMY ',
    description: 'facebook icon'
  },
  {
    img: reqSvgSocial(svgFileSocialPaths[1]),
    link: 'https://www.instagram.com/shopeepay_my/ ',
    description: 'instagram icon'
  }
]
//app stores
export const appStoresEng = [
  {
    img: reqSvgApp(svgFileAppPaths[0]),
    link: 'https://apps.apple.com/my/app/id959841113',
    description: 'Apple Store',
    width: '120px'
  },
  {
    img: reqSvgApp(svgFileAppPaths[1]),
    link: 'https://play.google.com/store/apps/details?id=com.shopee.my&referrer=af_tranid%3DZPoWZKWO_aJuSqfj4uXOCw%26pid%3DOrganicA%26c%3Dlp_home_and1 ',
    description: 'Google Play',
    width: '120px'
  },
  {
    img: reqSvgApp(svgFileAppPaths[2]),
    link: 'https://appgallery.huawei.com/app/C100576469?sharePrepath=ag&channelId=web&detailType=0 ',
    description: 'Hua Wei Store',
    width: '120px'
  }
]

export const appStoresMy = [
  {
    img: reqSvgApp(svgFileAppPaths[0]),
    link: ' https://apps.apple.com/my/app/id959841113 ',
    description: 'Apple Store',
    width: '120px'
  },
  {
    img: reqSvgApp(svgFileAppPaths[1]),
    link: 'https://play.google.com/store/apps/details?id=com.shopee.my&referrer=af_tranid%3DZPoWZKWO_aJuSqfj4uXOCw%26pid%3DOrganicA%26c%3Dlp_home_and1',
    description: 'Google Play',
    width: '120px'
  },
  {
    img: reqSvgApp(svgFileAppPaths[2]),
    link: 'https://appgallery.huawei.com/app/C100576469?sharePrepath=ag&channelId=web&detailType=0 ',
    description: 'Hua Wei Store',
    width: '120px'
  }
]
//bank icons
export const bankIconsEng = [
  {
    img: reqPngIcons(pngFileIconsPaths[0]),
    width: '50px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[1]),
    width: '100px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[2]),
    width: '60px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[3]),
    width: '90px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[4]),
    width: '70px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[5]),
    width: '80px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[6]),
    width: '90px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[7]),
    width: '120px'
  }
]

export const bankIconsMy = [
  {
    img: reqPngIcons(pngFileIconsPaths[0]),
    width: '50px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[1]),
    width: '100px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[2]),
    width: '60px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[3]),
    width: '90px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[4]),
    width: '70px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[5]),
    width: '80px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[6]),
    width: '90px'
  },
  {
    img: reqPngIcons(pngFileIconsPaths[7]),
    width: '120px'
  }
]

//extreme left box text
export const footerLeftTextEng = 'Eng Ikuti kami'
export const footerLeftTextMy = 'Ikuti kami'
export const footerLeftTextVnEng = 'Follow us'

//right half left box title
export const footerLeftUpperTitleEng = 'ENG Layanan pelanggan'
export const footerLeftUpperTitleMy = 'Layanan pelanggan'
export const footerLeftUpperTitleVn = 'Chăm sóc khách hàng'
export const footerLeftUpperTitleVnEng = 'Services'

//right box title
export const footerRightUpperTitleEng = 'ENG Jelajahi ShopeePay'
export const footerRightUpperTitleMy = 'Jelajahi ShopeePay'
export const footerRightUpperTitleVn = 'Khám phá ShopeePay'
export const footerRightUpperTitleVnEng = 'Explore ShopeePay'

export const companyName = 'Công ty Cổ phần ShopeePay - Tên thương mại ShopeePay'
export const address =
  'Địa chỉ: Tầng 5, Tháp 2, Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Hà Nội, Việt Nam'
export const paymentServicesIntro =
  'Dịch vụ trung gian thanh toán do Ngân hàng Nhà nước cấp phép được cung ứng thông qua Ứng dụng ShopeePay - Tài Chính Dễ Dàng:'
export const paymentServices = [
  '- Dịch vụ Ví điện tử',
  '- Dịch vụ hỗ trợ thu hộ, chi hộ',
  '- Dịch vụ cổng thanh toán điện tử'
]

//Left box links
export const leftBoxLinksEng = {
  shopeePayFeatures: ' ShopeePay Features',
  shopeePayApp: ' ShopeePay App',
  merchantFeatures: 'Merchant Features',
  promo: 'Promo',
  faqs: 'FAQ',
  blog: 'Shopee Blog'
}
export const leftBoxLinksMy = {
  shopeePayFeatures: ' MYShopeePay Features',
  shopeePayApp: ' MYShopeePay App',
  merchantFeatures: 'MY Merchant Features',
  promo: 'MY Promo',
  faqs: 'MY FAQ',
  blog: 'Shopee Blog'
}
export const leftBoxLinksVn = {
  merchantFeatures: 'Đối tác ShopeePay',
  promo: 'Chương trình khuyến mãi'
}
export const leftBoxLinksVnEng = {
  shopeePayFeatures: 'ShopeePay Feature',
  shopeePayApp: 'ShopeePay App',
  merchantFeatures: 'Merchant Feature',
  promo: 'Promotion',
  faqs: 'FAQ',
  blog: 'Shopee Blog'
}

//Right Box links
export const rightBoxLinksEng = {
  aboutUs: 'About Us',
  termsConditions: 'Terms and Conditions',
  PrivacyPolicy: 'Privacy Policy',
  contactUs: 'Contact Us'
}
export const rightBoxLinksMy = {
  aboutUs: 'MY About Us',
  termsConditions: 'MY Terms and Conditions',
  PrivacyPolicy: 'MY Privacy Policy',
  contactUs: 'MY Contact Us'
}

export const rightBoxLinksVn = {
  termsConditions: 'Điều khoản sử dụng',
  PrivacyPolicy: 'Chính sách bảo mật',
  SPLTermsConditions: 'Điều khoản sử dụng SPayLater',
  SEasyBuyerLoanTermsConditions: 'Điều khoản sử dụng SEasy Vay Tiền Nhanh',
  CashAdvanceTermsConditions: 'Điều khoản và điều kiện Dịch vụ Ứng Tiền Ngay'
}

export const rightBoxLinksVnEng = {
  aboutUs: 'About Us',
  termsConditions: 'Terms and Conditions',
  PrivacyPolicy: 'Privacy Policy',
  contactUs: 'Contact Us',
  partner: 'Become ShopeePay Partner',
  walletInfo: 'Change your ShopeePay wallet’s information'
}

export const footerLowerTextMy = 'METODE TOP UP'
export const footerLowerTextEng = 'ENG Metode Top Up'
export const footerFootnoteEng =
  'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.'
export const footerLowerTextVnEng = 'Top-up Method'
export const footerFootnoteMy = `© Shopee ${new Date().getFullYear()}. Hak Cipta Dilindungi.`
